import Button from '@vtex/styleguide/lib/Button';

export function VtexButton({ children, handleClick, ...otherProps }) {
	return (
		<Button onClick={handleClick} {...otherProps}>
			{children}
		</Button>
	);
}
